import * as React from 'react';
import styled from 'styled-components';
import { rem } from 'polished';
import { FlexColCenter } from '../../Defaults/Flexbox/Flexbox';
import { __ } from 'react-i18n';

export interface Props {
  text: string;
  height?: number;
}

function NotFound({ text, height = 100 }: Props) {
  return <Wrapper height={height}>{text}</Wrapper>;
}

const Wrapper = styled(FlexColCenter)<{ height: number }>`
  text-decoration: none;
  font-size: ${rem(18)};
  color: ${({ theme }) => `${theme.colors.textPrimary}`};
  width: 100%;
  padding: ${rem(16)} 0;
  height: ${({ height }) => rem(height)};
  justify-content: center;
`;

export { NotFound };
